module.exports = __webpack_public_path__ + "media/images/emoticons/freedial-473a345a47f71da1c6065916432dac52.gif";